import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';

type UndoActionProps = {
  providerName?: string;
  message?: string;
};

export const UndoAction = ({ providerName, message }: UndoActionProps) => (
  <Layout.Stack alignItems="left">
    <Text
      color="white"
      data-testid="remove-care-team-action-alert"
      fontWeight="bold"
    >{`${providerName} ${message}`}</Text>
  </Layout.Stack>
);
